import { ProjectConfig } from '../../interface/project.interface';

export const project: ProjectConfig = {
    version: '1.34.0',
    buildNumber: '0',
    mobileApiPath: 'sbg-mobile/rest',
    accountsFeatureKey: 'accounts'
};

export const scopes = {
    OPEN_ID: 'openid',
    PROFILE: 'profile',
    EMAIL: 'email',
    DIRECTORY_API: 'urn:pingidentity:directory-api',
    PLATFORM_ALL: 'sbg-platform.all',
    CORE_CUSTOMER_PLATFORM: 'sbg-corecustomerplatform.all',
    PAYMENTS: 'sbg-payment.all',
    SECURITY: 'securemessaging.*.post',
    WEALTH_INTERNATIONAL_SERVICES: 'wealthInternationalServices.*.*',
    BANKING_PBBI: 'banking-pbbi.*.*',
    CARDS: 'card-domain.*.*',
    MESSAGING: 'messaging.*.*'
};

export const channel = 'SBO_WEB';
